import React, { useEffect, useState } from "react";
import {Button, Modal} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import ModalControls from "../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../defaults/Forms";
import { absenceTypeDefault } from "../../../../defaults/Items";
import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import DeleteWarningModal from "../../common/DeleteWarningModal";
import TextInput from "../../../elements/TextInput";
import TextArea from "../../../elements/TextArea";
import Toggler from "../../../elements/Toggler";
import useCrud from "../../../../hooks/useCrud";
import { Table } from "../../../table/Table";

import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {HexColorPicker} from "react-colorful";

import "../../../../css/DictionaryForms.css";

const AbsenceType = () => {

  const dataUrl = "/absence-types";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = absenceTypeDefault;
  const itemName = "typ nieobecności";
  const itemNames = "typy nieobecności";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);
  const [itemColor, setItemColor] = useState("#ffffff");


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Skrócona nazwa", accessor: "shortName", sortable: true, searchable: true},
    {label: "Opis", accessor: "description", sortable: true, searchable: true},
    {label: "Kolor etykiety", accessor: "color", sortable: false, searchable: false, type: "color"},
    {label: "Wliczaj do limitu urlopów", accessor: "countsTowardVacationLimit", sortable: true, searchable: false, type: "bool"},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if (!currentItem.name || !currentItem.shortName) {
      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }

      if (!currentItem.shortName) {
        let shortNameInput = document.getElementById("shortName");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      shortName: currentItem.shortName,
      name: currentItem.name,
      description: currentItem.description,
      color: currentItem.color,
      countsTowardVacationLimit: !!currentItem.countsTowardVacationLimit
    };
    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);
    } else {
      response && onSaveAndClose({state});
    }
  }

  const changeColor = (itemColor) => {
    setItemChanged(!itemChanged);
    setItemColor(itemColor)
    setCurrentItem({...currentItem,
      color: itemColor});
    setCurrentFormState({...currentFormState, formSaveButtonDisabled: false});
  }


  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }

  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };

  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])

  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])

  useEffect(() => {
    const getData = async () => {
      const response = await getItems(dataUrl);
      if (response.status === 200) {
        setLoading(false);
        setItems(response.data);
      } else if (response.status === 401 || response.status === 403) {
        navigate('/login', {state: {from: location}, replace: true})
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowy Typ nieobecności`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }
  {console.log(currentItem)}
  const modalTitle = currentFormState.formAddingDataMode
    ? "Nowa pozycja: Typ nieobecności"
    : `Edycja: ${currentItem.name || "Typ nieobecności"}`;

  return (
    <div id="layoutSidenav_content" className="dictionary-page">
      <AppComponentCardHeader title="Pozycje słownika Typy nieobecności" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <Modal
        show={currentFormState.showForm}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        className="dictionary-form-modal"
        dialogClassName="dictionary-form-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dictionary-form-intro">
            <div>
              <strong>{currentFormState.formAddingDataMode ? "Dodajesz nową pozycję słownika" : "Edytujesz istniejącą pozycję słownika"}</strong>
              <span>Uzupełnij pola poniżej. Pola oznaczone gwiazdką są wymagane.</span>
            </div>
            {!currentFormState.formAddingDataMode && (
              <Button size="sm" variant="outline-secondary" onClick={() => {
                setUpdateConflict(false);
                restoreFormData({state});
              }}>
                Przywróć wartości
              </Button>
            )}
          </div>

          <form id="add-absence-type-form" name="add-absence-type-form" className="dictionary-form-grid">
            <div className="dictionary-form-field">
              <label htmlFor="name"><span className="required">*</span> Nazwa</label>
              <TextInput propertyName="name" required={true} state={state}/>
              <small>Pełna nazwa typu nieobecności.</small>
            </div>
            <div className="dictionary-form-field dictionary-form-field-short">
              <label htmlFor="shortName"><span className="required">*</span> Skrót</label>
              <TextInput propertyName="shortName" maxlen="10" required={true} state={state}/>
              <small>Maksymalnie 10 znaków.</small>
            </div>
            <div className="dictionary-form-field dictionary-form-field-full">
              <label htmlFor="description">Opis</label>
              <TextArea propertyName="description" required={false} rows="4" state={state}/>
            </div>
            <div className="dictionary-form-option-card">
              <div>
                <strong>Wliczaj do limitu urlopów działu</strong>
                <small>Po włączeniu ten typ nieobecności będzie uwzględniany w miesięcznym limicie urlopów działu.</small>
              </div>
              <Toggler propertyName="countsTowardVacationLimit" state={state}/>
            </div>
            <div className="dictionary-form-field dictionary-form-color-field">
              <label>Kolor etykiety</label>
              <div className="dictionary-color-layout">
                <HexColorPicker color={currentItem.color || itemColor || "#ffffff"} onChange={changeColor}/>
                <span className="dictionary-color-preview" style={{"--dictionary-preview-color": currentItem.color || itemColor || "#ffffff"}}>
                  Podgląd etykiety
                </span>
              </div>
            </div>
          </form>

          {updateConflict && (
            <div className="dictionary-form-error">
              <FontAwesomeIcon icon={faInfoCircle}/>
              <span>Nie można zapisać tej pozycji, ponieważ istnieje już wpis o tej nazwie lub skrócie.</span>
            </div>
          )}
        </Modal.Body>
        <ModalControls onDelete={onDelete} onCloseDetails={onClose} onSubmit={onSaveItemClick} state={state}/>
      </Modal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );

}

export default AbsenceType;
